<div class="footer-mobile" [ngClass]="{'relative-footer': isDetailsOpen}">
    <button pButton type="button" icon="pi pi-angle-left" (click)="changeMonth(-1)" [disabled]="disablePast" [ngClass]="{'btn-disabled': disablePast}"></button>
    <p-calendar class="mobile-calendar"
      [(ngModel)]="selectedDate"
      view="month"
      dateFormat="MM yy"
      (onSelect)="onCalendarSelect($event)"showClear=""
      [yearNavigator]="true"
      [monthNavigator]="true"
      [showIcon]="false"
      [minDate]="minSelectableDate"
      [maxDate]="maxSelectableDate"></p-calendar>
    <button pButton type="button" icon="pi pi-angle-right" (click)="changeMonth(1)" [disabled]="disableFuture" [ngClass]="{'btn-disabled': disableFuture}"></button>
  </div>
